import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

const HomePage = lazy(() =>
  import('./pages/HomePage').then((m) => ({ default: m.HomePage })),
);
const AboutPage = lazy(() =>
  import('./pages/AboutPage').then((m) => ({ default: m.AboutPage })),
);
const FeaturesPage = lazy(() =>
  import('./pages/FeaturesPage').then((m) => ({ default: m.FeaturesPage })),
);
const CategoriesPage = lazy(() =>
  import('./pages/CategoriesPage').then((m) => ({
    default: m.CategoriesPage,
  })),
);
const TerritoriesPage = lazy(() =>
  import('./pages/TerritoriesPage').then((m) => ({
    default: m.TerritoriesPage,
  })),
);
const ContactPage = lazy(() =>
  import('./pages/ContactPage').then((m) => ({ default: m.ContactPage })),
);
const LegalPrivacyPage = lazy(() =>
  import('./pages/LegalPrivacyPage').then((m) => ({
    default: m.LegalPrivacyPage,
  })),
);
const LegalTermsPage = lazy(() =>
  import('./pages/LegalTermsPage').then((m) => ({
    default: m.LegalTermsPage,
  })),
);
const LegalMentionsPage = lazy(() =>
  import('./pages/LegalMentionsPage').then((m) => ({
    default: m.LegalMentionsPage,
  })),
);
const NotFoundPage = lazy(() =>
  import('./pages/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
);

function Fallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <CircularProgress />
    </Box>
  );
}

const withSuspense = (el: ReactNode) => (
  <Suspense fallback={<Fallback />}>{el}</Suspense>
);

export const router = createBrowserRouter([
  { path: '/', element: withSuspense(<HomePage />) },
  { path: '/about', element: withSuspense(<AboutPage />) },
  { path: '/features', element: withSuspense(<FeaturesPage />) },
  { path: '/categories', element: withSuspense(<CategoriesPage />) },
  { path: '/territoires', element: withSuspense(<TerritoriesPage />) },
  { path: '/contact', element: withSuspense(<ContactPage />) },
  { path: '/legal/privacy', element: withSuspense(<LegalPrivacyPage />) },
  { path: '/legal/terms', element: withSuspense(<LegalTermsPage />) },
  { path: '/legal/mentions', element: withSuspense(<LegalMentionsPage />) },
  { path: '*', element: withSuspense(<NotFoundPage />) },
]);

export default router;
